import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';

import cadastrarRota from '../../actions/rota/cadastrarRota'
import {renderField, renderFieldCheck, required} from '../../util/inputs';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarRota from '../../actions/rota/selecionarRota';
import SelecaoCidadeAutocompleteRotaConexao from './SelecaoCidadeAutocompleteRotaConexao';
import {showSuccessMsg} from '../../util/messagesUtil';

export const renderFieldAutoCompleteCidadade = ({
  selecionarCidade,
  placeholder,
  valor,
  meta: { touched, error }
}) => (
  <div>
    <SelecaoCidadeAutocompleteRotaConexao placeholder={placeholder}
                               selecionarCidade={selecionarCidade}
                               value={valor}/>
    {touched
    && (error && <span style={{ color: 'red' }}>{error}</span>)}
  </div>
);

export class ModalCadastrarRota extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  fecharModal () {
    $('#modalCadastrarRota')
      .modal('hide');
    $('#modalCadastrarRota')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.props.selecionarOrigem(null);
    this.props.selecionarDestino(null);
    this.props.selecionarRota(null);
    this.props.reset('formularioCadastroRota');
    // random para forçar limpeza do componente limpezaCidadeAutocomplete
    this.props.changeFieldValue('formularioCadastroRota',
      'cidadeOrigem', Math.random());
    this.props.changeFieldValue('formularioCadastroRota',
      'cidadeDestino', Math.random());
  }

  montarParametroCriacaoRota(values) {
    return {
      id: this.props.rotaSelecionada? this.props.rotaSelecionada.id : null,
      cidadeOrigemId: this.props.origem.id ,
      cidadeDestinoId: this.props.destino.id,
      delimitacao: values.delimitacao,
      prefixo: values.prefixo,
      empresaId: this.props.empresaSelecionada.id,
      exibeTrechoAlternativo: values.opcoesTrechoAlternativo
    };
  }

  submit (values) {
      this.props.cadastrarRota(this.montarParametroCriacaoRota(values))
        .then(() => {
            showSuccessMsg(`Rota ${this.props.rotaSelecionada? 'atualizada' : 'cadastrada'} com sucesso`);
            this.props.buscarRotas();
            this.fecharModal();
        })
  }


  render () {
    const {
      handleSubmit, invalid, submitting
    } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarRota' role='dialog'
           aria-labelledby='modalCadastrarRota' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>{this.props.rotaSelecionada ? 'Editar Rota' : 'Nova Rota'}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="material-icons" onClick={()=> this.fecharModal()}>
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="form-row">
                      <div className="col-12 col-sm-4 col-md-4">
                        <Field name="prefixo" type="text" component={renderField} label="Prefixo:"
                               css="form-control" readOnly={false} validate={[required]}/>
                      </div>
                      <div className="col-12 col-sm-8 col-md-8">
                        <Field name="delimitacao" type="text" component={renderField} label="Delimitação:"
                               css="form-control" readOnly={false} validate={[required]}/>
                      </div>
                    </div>
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-9 col-md-6">
                        <Field name='cidadeOrigem'
                              component={renderFieldAutoCompleteCidadade}
                              selecionarCidade={this.props.selecionarOrigem}
                              valor={this.props.cidadeOrigem}
                              placeholder='Cidade de Origem'/>

                      </div>
                      <div className="col-12 col-sm-9 col-md-6">
                        <Field name='cidadeDestino'
                               component={renderFieldAutoCompleteCidadade}
                               selecionarCidade={this.props.selecionarDestino}
                               valor={this.props.cidadeDestino}
                               placeholder='Cidade de Destino'/>

                      </div>
                    </div>
                    {this.props.empresaSelecionada.opcoesTrechoAlternativo
                      ? <Field name='opcoesTrechoAlternativo' type="checkbox" component={renderFieldCheck} label="Exibir trecho alternativo"
                               css="form-check-input" readOnly={false}/> : ''}
                  </div>

                </div>
                <div className="modal-footer">
                  <button type="submit" disabled={invalid || submitting || !this.props.origem || !this.props.destino}
                          className="btn btn-laranja">Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    initialValues:{
      cidadeOrigem: state.rotaSelecionada ? state.rotaSelecionada.cidadeOrigem : null,
      cidadeDestino: state.rotaSelecionada ? state.rotaSelecionada.cidadeDestino : null,
      opcoesTrechoAlternativo: state.rotaSelecionada ? state.rotaSelecionada.opcoesTrechoAlternativo : null,
      prefixo: state.rotaSelecionada ? state.rotaSelecionada.prefixo : null,
      delimitacao: state.rotaSelecionada ? state.rotaSelecionada.delimitacao : null
    },
    cidadeOrigem: formValueSelector('formularioCadastroRota')(state, 'cidadeOrigem'),
    cidadeDestino: formValueSelector('formularioCadastroRota')(state, 'cidadeDestino'),
    prefixo: formValueSelector('formularioCadastroRota')(state, 'prefixo'),
    delimitacao: formValueSelector('formularioCadastroRota')(state, 'delimitacao'),
    opcoesTrechoAlternativo: formValueSelector('formularioCadastroRota')(state, 'opcoesTrechoAlternativo'),
    empresaSelecionada: state.empresaSelecionada,
    rotaSelecionada: state.rotaSelecionada,
    origem: state.origem,
    destino: state.destino
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarRota,
    selecionarOrigem,
    selecionarDestino,
    selecionarRota
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroRota',
  enableReinitialize: true,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(ModalCadastrarRota));
